import {
  ButtonProps,
  CircularProgress,
  Button as MUIButton,
} from '@mui/material';
import { MouseEvent, useCallback, useMemo } from 'react';

const circularProgressSizeMap: Record<keyof ButtonProps['size'], 'string'> = {
  small: '16px',
  medium: '18px',
  large: '20px',
  extraLarge: '22px',
};

export const Button = (props: ButtonProps) => {
  const {
    children,
    disabled,
    loading,
    startIcon,
    size,
    color,
    onClick,
    disableRipple,
    disableFocusRipple,
    ...args
  } = props;

  const _startIcon = useMemo(() => {
    if (loading) {
      return (
        <CircularProgress size={circularProgressSizeMap[size || 'medium']} />
      );
    }

    return startIcon;
  }, [loading, size, startIcon]);

  const _onClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      if (!onClick) return undefined;

      if (loading) {
        e.stopPropagation();
        e.preventDefault();
        return undefined;
      }

      return onClick(e);
    },
    [loading, onClick],
  );

  return (
    <MUIButton
      {...args}
      size={size}
      color={color}
      disabled={!!(disabled || loading)}
      loading={loading || undefined}
      startIcon={_startIcon}
      onClick={_onClick}
      disableRipple={disableRipple}
      disableFocusRipple={disableFocusRipple}
    >
      {children}
    </MUIButton>
  );
};
